import React from 'react';
import { Layers, PenTool, Figma, Code, Users, BarChart } from 'lucide-react';
import { motion } from 'framer-motion';
export const Skills = () => {
  const skills = [{
    icon: <Layers className="text-white" size={24} data-id="element-191" />,
    title: 'User Experience (UX) Design',
    description: 'Creating intuitive, accessible, and user-friendly digital experiences based on research and testing.'
  }, {
    icon: <PenTool className="text-white" size={24} data-id="element-192" />,
    title: 'User Interface (UI) Design',
    description: 'Crafting visually appealing interfaces with attention to typography, color theory, and visual hierarchy.'
  }, {
    icon: <Figma className="text-white" size={24} data-id="element-193" />,
    title: 'Prototyping',
    description: 'Building interactive prototypes that effectively communicate design concepts and functionality.'
  }, {
    icon: <Code className="text-white" size={24} data-id="element-194" />,
    title: 'Front-end Development',
    description: 'Working knowledge of HTML, CSS, and JavaScript to better collaborate with development teams.'
  }, {
    icon: <Users className="text-white" size={24} data-id="element-195" />,
    title: 'User Research',
    description: 'Conducting interviews, surveys, and usability tests to inform design decisions.'
  }, {
    icon: <BarChart className="text-white" size={24} data-id="element-196" />,
    title: 'Design Strategy',
    description: 'Aligning design solutions with business goals and user needs for maximum impact.'
  }];
  return <section id="skills" className="py-20 bg-gray-50 dark:bg-gray-800 transition-colors" data-id="element-197">
      <div className="container mx-auto px-4 md:px-6" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-199">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-200">
            My Skills & Services
          </h2>
          <div className="w-20 h-1 bg-indigo-600 dark:bg-indigo-400 mx-auto mb-6" data-id="element-201"></div>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-202">
            I offer a comprehensive range of design services to help businesses
            create exceptional digital experiences for their users.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-203">
          {skills.map((skill, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)'
        }} className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md transition-colors" data-id="element-204">
              <motion.div whileHover={{
            scale: 1.1,
            rotate: 5
          }} transition={{
            duration: 0.3
          }} className="bg-indigo-600 dark:bg-indigo-500 rounded-full w-12 h-12 flex items-center justify-center mb-6" data-id="element-205">
                {skill.icon}
              </motion.div>
              <h3 className="text-xl font-bold mb-3 text-gray-900 dark:text-white" data-id="element-206">
                {skill.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-207">
                {skill.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};